import { QueryClient } from '@tanstack/vue-query'

/*
 * 앱 전역 단일 QueryClient.
 *
 * VueQueryPlugin 에 이 인스턴스를 주입하므로(main.js), 컴포넌트 안(useQueryClient())과
 * 컴포넌트 밖(Vuex 모듈·plain JS 컨트롤러에서 직접 import) 어디서든 같은 캐시를 공유한다.
 */
export const queryClient = new QueryClient()
